module.exports = __webpack_public_path__ + "static/media/boy-blink.3b60dfb9.png";